import { useTranslation } from 'react-i18next';
import { getDurationStr } from '@amzn/atoz-shiftapp-utilities';
import { formatBreakdownDetailStr, getCurrencyRangeStr } from '../../../../utils';
// TODO: Replace with generated GQL types when available
var PayCategory;
(function (PayCategory) {
    PayCategory["Base"] = "BASE";
    PayCategory["ShiftDifferential"] = "SHIFT_DIFFERENTIAL";
    PayCategory["HighDemandPremium"] = "HIGH_DEMAND_PREMIUM";
    PayCategory["NightAndWeekendPremium"] = "NIGHT_AND_WEEKEND_PREMIUM";
    PayCategory["PeakHiringPremium"] = "PEAK_HIRING_PREMIUM";
})(PayCategory || (PayCategory = {}));
export var usePayBreakdown = function (_a) {
    var _b, _c, _d;
    var payBreakdown = _a.payBreakdown;
    var t = useTranslation().t;
    var mapPremiumsToLineProps = function (premiums) {
        return premiums.map(function (premium) {
            var _a;
            var category = premium.category;
            return {
                dataTestId: "ShiftPayBreakdownEstimatedShift".concat(category),
                descriptionText: "".concat(t("shift_management_features_PayBreakdown_category_".concat(category)), " ").concat(formatBreakdownDetailStr(premium.hourlyCompensation, premium.durationRange)),
                rateText: (_a = getCurrencyRangeStr(premium.totalCompensationRange, {
                    forceRationalFormatting: true
                })) !== null && _a !== void 0 ? _a : ''
            };
        });
    };
    return {
        baseLineItemProps: {
            dataTestId: 'ShiftPayBreakdownEstimatedShiftBase',
            descriptionText: "".concat(t('shift_management_features_PayBreakdown_category_BASE'), " ").concat(formatBreakdownDetailStr(payBreakdown.base.hourlyCompensation, payBreakdown.base.durationRange)),
            rateText: (_b = getCurrencyRangeStr(payBreakdown.base.totalCompensationRange, {
                forceRationalFormatting: true
            })) !== null && _b !== void 0 ? _b : ''
        },
        shiftDifferentialLineItemProps: payBreakdown.shiftDifferential
            ? {
                dataTestId: 'ShiftPayBreakdownEstimatedShiftDifferential',
                descriptionText: "".concat(t('shift_management_features_PayBreakdown_category_SHIFT_DIFFERENTIAL'), " ").concat(formatBreakdownDetailStr(payBreakdown.shiftDifferential.hourlyCompensation, payBreakdown.shiftDifferential.durationRange)),
                rateText: (_c = getCurrencyRangeStr(payBreakdown.shiftDifferential.totalCompensationRange, {
                    forceRationalFormatting: true
                })) !== null && _c !== void 0 ? _c : ''
            }
            : undefined,
        premiumsLineItemsProps: payBreakdown.premiums
            ? mapPremiumsToLineProps(payBreakdown.premiums)
            : undefined,
        totalLineItemProps: {
            dataTestId: 'ShiftPayBreakdownEstimatedShiftTotal',
            descriptionText: t('shift_management_features_PayBreakdown_total'),
            rateText: (_d = getCurrencyRangeStr(payBreakdown.summary.totalShiftPayRange, {
                forceRationalFormatting: true
            })) !== null && _d !== void 0 ? _d : '',
            isBold: true
        },
        averageLineItemProps: {
            dataTestId: 'ShiftPayBreakdownEstimatedShiftAverage',
            descriptionText: "".concat(t('shift_management_features_PayBreakdown_average'), " (").concat(getCurrencyRangeStr(payBreakdown.summary.totalShiftPayRange, {
                forceRationalFormatting: true
            }), " / ").concat(getDurationStr(payBreakdown.summary.duration), ")"),
            rateText: "".concat(getCurrencyRangeStr(payBreakdown.summary.hourlyShiftRateRange, { forceRationalFormatting: true }), "/").concat(t('shift_management_common_time_hourAbbr'))
        }
    };
};
